import React, { useState } from 'react';
import { Button, Grid, TextField } from '@mui/material';
import { handleError, handleWarning } from '../../helpers/utils';
import { getProviders } from '../../actions/provider';

export const SearcherProvider = ({
	generateRows = null,
	rowsState = 5,
	handleClose = null,
	setRowsState = null,
}) => {
	// Searcher
	const [searchField, setSearchField] = useState('');
	// const [selectedOption, setSelectedOption] = useState(null);

	const handleSearch = () => {
		if (searchField === '') {
			handleWarning('Hacen falta campos para poder buscar');
		} else {
			const endpoint = `/api/client/provider/?ordering=-created_at&search=${searchField}`;
			getProviders(`${endpoint}&page_size=${rowsState.pageSize}`)
				.then(({ data }) => {
					generateRows(data);
					setRowsState((old) => ({
						...old,
						next: data.next,
						previous: data.previous,
						current: endpoint,
					}));
				})
				.catch((error) => {
					handleError(error, 'No se pudo realizar la búsqueda');
					generateRows(null);
				});
		}
	};

	return (
		<Grid
			container
			component='main'
			spacing={1}
			style={{
				width: '50%',
				margin: '10px 0 15px 0',
			}}
		>
			<Grid item xs={12}>
				<TextField
					required
					style={{ margin: '0 auto' }}
					label='Valor'
					value={searchField}
					onChange={({ target }) => setSearchField(target.value)}
					onKeyDown={({ key }) => {
						if (key === 'Enter') {
							handleSearch();
						}
					}}
				/>
			</Grid>

			<Grid item xs={4} style={{ display: 'flex', flexDirection: 'row' }}>
				<Button variant='text' onClick={handleSearch}>
					Buscar
				</Button>
				<Button
					color='error'
					variant='text'
					onClick={() => {
						handleClose();
						generateRows(null);
						setSearchField('');
					}}
				>
					Cerrar
				</Button>
			</Grid>
		</Grid>
	);
};
